import { IAppState } from "@edp-store/state/app.state";
import { IDeepLinkState } from "@edp-store/state/deep-link.state";
import { createSelector } from "@ngrx/store";

const deepLinkSelector = (state: IAppState) => state.deepLink;

export const getDeepLink = createSelector(
    deepLinkSelector,
    (state: IDeepLinkState) => state.deepLink
);
